import { render } from "./TeachTemp.vue?vue&type=template&id=1b3b68a8&scoped=true"
import script from "./TeachTemp.vue?vue&type=script&lang=js"
export * from "./TeachTemp.vue?vue&type=script&lang=js"

import "./TeachTemp.vue?vue&type=style&index=0&id=1b3b68a8&lang=scss&scoped=true"

import exportComponent from "D:\\pro\\edu-hsd\\cxcj\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b3b68a8"]])

export default __exports__